import React from 'react';

interface YachtIconProps {
  size?: number;
  color?: string;
}

export const YachtIcon: React.FC<YachtIconProps> = ({ 
  size = 24, 
  color = '#00b96b'
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill={color}
      style={{ marginRight: '8px' }}
    >
      <path d="M56,48h-5H37v-1h13c0.341,0,0.659-0.174,0.843-0.462c0.184-0.287,0.208-0.648,0.064-0.958L35.944,13.279 C35.97,13.189,36,13.099,36,13V1c0-0.553-0.448-1-1-1s-1,0.447-1,1v8.083l-0.093-0.2c-0.167-0.36-0.506-0.603-0.93-0.58 c-0.397,0.01-0.752,0.253-0.903,0.622L32,9.106V5c0-0.45-0.301-0.845-0.735-0.964c-0.434-0.121-0.895,0.066-1.125,0.453l-22,37 c-0.184,0.309-0.188,0.692-0.01,1.005C8.308,42.807,8.641,43,9,43h9.146l-1.072,2.622c-0.041,0.099-0.058,0.203-0.066,0.308 c-0.002,0.025-0.002,0.049-0.001,0.074c0,0.114,0.014,0.228,0.053,0.336c0.001,0.003,0.003,0.006,0.005,0.009 c0.027,0.073,0.061,0.143,0.106,0.209c0.022,0.032,0.051,0.058,0.076,0.087c0.009,0.011,0.012,0.025,0.022,0.036 c0.007,0.007,0.016,0.009,0.023,0.016c0.085,0.087,0.183,0.156,0.293,0.206c0.022,0.01,0.043,0.017,0.065,0.025 C17.76,46.971,17.877,47,18,47h17v1H10c-0.351,0-0.677,0.185-0.857,0.485l-6,10c-0.186,0.309-0.19,0.693-0.013,1.008 C3.307,59.807,3.64,60,4,60h38c5.358,0,9.447-5.09,9.948-10H56c0.552,0,1-0.447,1-1S56.552,48,56,48z M33.057,11.806l5.013,10.822 c-3.436,7.541-4.027,8.043-9.571,12.742c-1.953,1.656-4.472,3.793-7.885,6.879L33.057,11.806z M10.758,41L30,8.639v5.36L18.963,41 H10.758z M20.559,45c4.122-3.772,7.033-6.239,9.234-8.104c5.329-4.518,6.349-5.388,9.381-11.885L48.435,45H20.559z M42,58H5.766 l1.8-3h40.221C46.355,56.767,44.329,58,42,58z M49.045,53.009C49.029,53.008,49.016,53,49,53H8.766l1.8-3H35h2h12.939 C49.815,51.022,49.505,52.047,49.045,53.009z" />
    </svg>
  );
};
